<template>
<!-- This example requires Tailwind CSS v2.0+ -->
<nav class="bg-gray-100 dark:bg-gray-900 transition-colors duration-500 ease-in-out" id="navbar">
  <div class="max-w-7xl mx-auto px-2 sm:px-6 lg:px-8">
    <div class="relative flex items-center justify-between h-16">
      <div class="absolute inset-y-0 left-0 flex items-center sm:hidden">
        <!-- Mobile menu button-->
        <button class="z-10 inline-flex items-center justify-center p-2 rounded-md text-gray-800 dark:text-gray-100 hover:bg-gray-600 hover:text-white focus:outline-none focus:ring-2 focus:ring-inset focus:ring-white" 
            aria-expanded="true"
            @click="$store.commit('showMobileMenu')">
          <span class="sr-only">Open main menu</span>
          <!-- Icon when menu is closed. -->
          <!--
            Heroicon name: menu

            Menu open: "hidden", Menu closed: "block"
          -->
          <svg class="block h-6 w-6" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" aria-hidden="true">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 6h16M4 12h16M4 18h16" />
          </svg>
          <!-- Icon when menu is open. -->
          <!--
            Heroicon name: x

            Menu open: "block", Menu closed: "hidden"
          -->
          <svg class="hidden h-6 w-6" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" aria-hidden="true">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
          </svg>
        </button>
      </div>
      <div class="flex-1 flex items-center justify-center sm:items-stretch sm:justify-start">
        <div class="flex-shrink-0 flex items-center">
            <vue-text-glitch
          :text="navbar.title"
          class="font-bold text-gray-800 dark:text-gray-400"
          fill="text-gray-800"
          :background="''"
          highlight2="yellow"
          highlight1="red"
          :steps="18"
          ></vue-text-glitch>
        </div>
        <div class="hidden sm:block sm:ml-6">
          <div class="flex space-x-4">

            <!-- NAVBAR ITEMS -->
            <router-link  v-for="(item, n) in navbar.items" :key="n"
                :class="[
                  'z-10 px-3 py-2 rounded-md text-sm font-medium cursor-pointer transition-colors duration-500 ease-in-out', 
                  selected==item.key ? 'bg-blueGray-500 dark:bg-blueGray-700 text-white dark:text-blueGray-300':'hover:bg-blueGray-700 dark:hover:bg-blueGray-800 hover:text-blueGray-300  text-blueGray-800 dark:text-blueGray-300']"
                :to="item.path" >
                <fa :icon="item.icon" v-if="item.icon != ''" /> {{item.name}}
            </router-link>
            <!-- /NAVBAR ITEMS -->

            <!-- <a href="#" class="px-3 py-2 rounded-md text-sm font-medium text-gray-300 hover:text-white hover:bg-gray-700">Team</a> -->
            <!-- <a href="#" class="px-3 py-2 rounded-md text-sm font-medium text-gray-300 hover:text-white hover:bg-gray-700">Calendar</a> -->
          </div>
        </div>
      </div>
      <div class="absolute inset-y-0 right-0 flex items-center pr-2 sm:static sm:inset-auto sm:ml-6 sm:pr-0 z-50">
      <!-- DARK MODE BUTTON -->
        <div class="hidden md:inline-block relative w-10 mr-2 align-middle select-none transition duration-200 ease-in">
            <input type="checkbox" name="toggle" id="toggle" 
              class="toggle-checkbox absolute block w-6 h-6 rounded-full bg-white border-4 appearance-none cursor-pointer" 
              @change="$store.commit('changeDarkMode')" />
            <label for="toggle" class="toggle-label block overflow-hidden h-6 rounded-full bg-gray-400 cursor-pointer"></label>
        </div>
        <label for="toggle" class="hidden md:block text-xs text-gray-700 dark:text-gray-400 mr-2">{{navbar.darkMode}}</label>
      <!-- /DARK MODE BUTTON -->
      


        <!-- Profile dropdown -->
        <div class="ml-3 relative">
          <div>
            <button @click="$store.commit('showContact')" 
            class="bg-gray-800 flex text-sm rounded-full focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-gray-800 focus:ring-white" 
            id="user-menu" aria-haspopup="true" >
              <span class="sr-only">Open user menu</span>
              <img class="h-8 w-8 rounded-full" src="/images/HijaEmma.jpeg" alt="Hija Emma">
            </button>
          </div>
          <!--
            Profile dropdown panel, show/hide based on dropdown state.

            Entering: "transition ease-out duration-100"
              From: "transform opacity-0 scale-95"
              To: "transform opacity-100 scale-100"
            Leaving: "transition ease-in duration-75"
              From: "transform opacity-100 scale-100"
              To: "transform opacity-0 scale-95"
          -->
          <transition name="flipX">
          <div v-if="navbar.show.profile" class="origin-top-right absolute right-0 mt-2 w-48 rounded-md shadow-lg py-1 bg-white dark:bg-gray-700 ring-1 ring-black ring-opacity-5" role="menu" aria-orientation="vertical" aria-labelledby="user-menu">
            
            <a v-for="(item,n) in navbar.contact.items" :key="n"
              :href="item.path" 
              target="_blank" 
              class="block px-4 py-2 text-sm text-gray-700 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-900" 
              role="menuitem">{{item.name}}</a>           
          </div>
          </transition>
        </div>
      </div>
    </div>
  </div>

  <!--
    Mobile menu, toggle classes based on menu state.

    Menu open: "block", Menu closed: "hidden"
  -->
  <transition name="lightSpeed">
  <div v-if="navbar.show.mobileMenu" class="z-20 absolute top-14 bg-opacity-90 w-full bg-gray-500 dark:bg-gray-800 transition-colors duration-500 ease-in-out">
    <div class="px-2 pt-2 pb-3 space-y-1">
      <router-link v-for="(item, n) in navbar.items" :key="n"
        :class="['z-30 block px-3 py-2 rounded-md text-sm font-medium', selected==item.key ? 'bg-gray-200 dark:bg-gray-900 text-gray-900 dark:text-white':'hover:bg-gray-700 text-gray-300']" 
        :to="item.path"><fa :icon="item.icon" v-if="item.icon != ''" /> {{item.name}}
      </router-link>
      <hr>
      <a @click="$store.commit('changeDarkMode')" 
      class="block px-2 py-1 text-center text-base font-medium text-gray-100"><span>{{navbar.darkMode}}</span> <span><fa :icon="darkMode ? 'moon':'sun'" /></span></a>
      <!-- <a href="#" class="block px-3 py-2 rounded-md text-base font-medium text-gray-300 hover:text-white hover:bg-gray-700">Calendar</a> -->
    </div>
  </div>
  </transition>
</nav>
</template>

<script>
import VueTextGlitch from 'vue-text-glitch'
export default {
 name: 'Navbar',
 components: {
   VueTextGlitch,
 },
 props: {
     selected: {
         default: 'index',
         type: String
     }
 },
 computed: {
   navbar() {
     return this.$store.getters.GetNavbar
   },
   darkMode() {
     return this.$store.getters.GetDarkMode
   }
 }
}
</script>

<style>
/* CHECKBOX TOGGLE SWITCH */
/* @apply rules for documentation, these do not work as inline style */
.toggle-checkbox:checked {
  right: 0;
  /* border-color: #1F2937; */
}
/* .toggle-checkbox:checked + .toggle-label {
  background-color: #1F2937;
} */
</style>